// Next Imports
import Link from "next/link";

// MUI Imports
import { Box, Button, Grid2 as Grid, Typography } from "@mui/material";

function Header() {
  return (
    <Grid
      container
      spacing={3}
      marginTop={{ xs: "10px", md: "34px" }}
      marginBottom={"34px"}
      sx={{
        backgroundColor: "#ffffff",
        borderRadius: "20px",
        padding: { xs: "25px 10px", sm: "50px 40px" },
      }}
    >
      <Grid
        size={{ xs: 12, md: 7 }}
        sx={{
          display: { xs: "flex", md: "block" },
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="h1"
          sx={{
            display: "flex",
            marginBottom: "10px",
            fontWeight: 900,
            fontSize: { xs: "24px", sm: "34px", lg: "45px" },
            lineHeight: 1.1,
          }}
        >
          <Typography
            component="span"
            sx={{
              color: "#2D3748",
              marginRight: "8px",
              fontWeight: 900,
              fontSize: { xs: "24px", sm: "34px", lg: "45px" },
              lineHeight: 1.1,
            }}
          >
            Hi, I'm
          </Typography>

          <Typography
            component="span"
            sx={{
              color: "#667EEA",
              fontWeight: 900,
              fontSize: { xs: "24px", sm: "34px", lg: "45px" },
              lineHeight: 1.1,
            }}
          >
            Valentin-Marko
          </Typography>

          <Typography
            component="span"
            sx={{
              color: "#2D3748",
              marginLeft: "2px",
            }}
          >
            .
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            component={"p"}
            variant="body1"
            sx={{
              fontSize: { xs: "24px", sm: "34px", lg: "45px" },
              fontWeight: 900,
              color: "#2D3748",
              marginBottom: "20px",
            }}
          >
            Full Stack Developer
          </Typography>
          <Typography
            component={"p"}
            variant="body2"
            sx={{
              fontSize: { xs: "16px", sm: "23px", lg: "28px" },
              fontWeight: 700,
              fontFamily: "Inter",
              color: "#748398",
              marginRight: "8px",
            }}
          >
            Specialized in React.js and Node.js
          </Typography>
        </Box>
        <Box sx={{ marginTop: "32px" }}>
          <Button
            component={Link}
            href="/contact"
            sx={{
              borderRadius: "30px",
              padding: { xs: "6px 12px", sm: "8px 24px" },
              backgroundColor: "#667EEA",
              color: "#ffffff",
              textTransform: "none",
              fontSize: { xs: "12px", sm: "16px" },
              fontWeight: 400,
              marginRight: "10px",
              border: { xs: "2px solid #667EEA", sm: "3px solid #667EEA" },
              "&:hover": {
                backgroundColor: "#7F8DA1", // Prevents background change
                border: { xs: "2px solid #7F8DA1", sm: "3px solid #7F8DA1" },
              },
            }}
          >
            Contact Me
          </Button>
          <Button
            component={Link}
            href="/about"
            sx={{
              borderRadius: "30px",
              padding: { xs: "6px 12px", sm: "8px 24px" },
              backgroundColor: "#EDF2F7",
              color: "#7F8DA1",
              textTransform: "none",
              fontSize: { xs: "12px", sm: "16px" },
              fontWeight: 400,
              border: { xs: "2px solid #7F8DA1", sm: "3px solid #7F8DA1" },
              "&:hover": {
                borderColor: "#667EEA", // Prevents background change
              },
            }}
          >
            About Me
          </Button>
        </Box>
      </Grid>

      <Grid
        size={{ xs: 12, md: 5 }}
        sx={{
          display: { md: "flex", xs: "none" },
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        {/* Decorative background circle */}
        <Box
          sx={{
            width: 360,
            height: 360,
            borderRadius: "50%",
            backgroundColor: "#667EEA",
            position: "absolute",
          }}
        />

        {/* Profile image */}
        <Box
          component="img"
          src="/profilePhoto6.webp" // put image in /public
          alt="Profile photo of Valentin-Marko"
          sx={{
            width: 300,
            height: 300,
            borderRadius: "50%",
            objectFit: "cover",
            zIndex: 2,
            border: "10px solid #ffffff",
          }}
        />
      </Grid>
    </Grid>
  );
}

export default Header;
